import { Truck } from "lucide-react";

const ITEMS = [
  "Primary Liability $750K–$5M",
  "Motor Truck Cargo $100K–$1M",
  "Physical Damage",
  "General Liability",
  "Bobtail Liability",
  "Trailer Interchange",
  "Reefer Breakdown",
  "Non-Trucking Liability",
];

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span
        key={i}
        className="flex items-center gap-8 whitespace-nowrap pr-8 font-mono text-xs uppercase tracking-[0.3em] text-white/75"
      >
        {item}
        <Truck className="h-4 w-4 shrink-0 text-brand-orange" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="coverage-marquee" className="overflow-hidden bg-brand-navy py-5">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
